import styled from "styled-components";
import { Upload } from "@security-watchdog/ui-components";

import { DEVICE } from "src/constants";

export const StyledUpload = styled(Upload)`
  @media (max-width: ${DEVICE.MOBILE_S}) {
    padding: 8px;
    max-height: unset;
  }
`;
